import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnChanges, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'env/environment';

@Component({
  selector: 'app-content-side-nav',
  standalone: true,
  imports: [TranslateModule, NgClass],
  templateUrl: './content-side-nav.component.html',
  styleUrl: './content-side-nav.component.scss'
})
export class ContentSideNavComponent implements OnInit, OnChanges {
  @ViewChildren('navButton') navButtons!: QueryList<ElementRef>;
  @Input() navItems!: string[];
  @Input() navItemsCounts?: { [key: string]: number };
  @Input() disabledItems: string[] = [];
  @Input() unreadIcon?: string[];
  @Input() activeItem?: string;
  @Input() type?: string;
  @Input() shouldTranslate: boolean = false;
  @Input() changeBack: boolean = false;
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();
  currentlySelected: string = '';

  get shouldRenderMobileNav(): boolean {
    return false;
  }

  get isMobile(): boolean {
    return environment.isMobile;
  }

  ngOnInit() {
    if (this.activeItem) {
      this.currentlySelected = this.activeItem;
    } else {
      this.currentlySelected = this.navItems[0];
    }

    this.itemSelected.emit(this.currentlySelected);
  }

  ngOnChanges(): void {
    if (this.activeItem) {
      this.currentlySelected = this.activeItem;
    }
  }

  isDisabled(item: string): boolean {
    return this.disabledItems.includes(item);
  }

  handleClick(item: string, index: number) {
    if (this.isDisabled(item)) return;
    if (!this.activeItem) {
      this.currentlySelected = item;
    }
    this.itemSelected.emit(item);

    if (index !== -1) {
      this.navButtons.toArray()[index].nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  hasCount(item: string): boolean {
    return (this.navItemsCounts && Object.prototype.hasOwnProperty.call(this.navItemsCounts, item)) || false;
  }

  // Method to access buttons programmatically if needed
  getNavButtons(): ElementRef[] {
    return this.navButtons.toArray();
  }
}
